import { Component, HostBinding, inject, OnDestroy, OnInit } from '@angular/core';
import { ScreenLoggedService } from 'src/app/core/services/screenLogged.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../../package.json';
import { DropdownUserComponent } from './dropdown-user/dropdown-user.component';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { NzDropDownDirective, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { RouterLink } from '@angular/router';
import { ScreenDto } from 'src/app/shared/dto/screen.dto';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { MenuComponent } from './menu/menu.component';
import { PauseService } from '../../services/pause.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        NzDropDownDirective,
        ɵNzTransitionPatchDirective,
        NzDropdownMenuComponent,
        DropdownUserComponent,
        NzMenuModule,
        MenuComponent
    ],
})
export class NavbarComponent implements OnInit, OnDestroy {
    // adds padding to the top of the document, so the content is below the header
    @HostBinding('class.bx--header') headerClass = true;

    loggedScreen: ScreenDto | null = null;
    environment: any;
    version: any = packageJson.version;
    currentRoute!: string;
    countPauses = 0;

    private readonly screenLoggedService = inject(ScreenLoggedService);
    private readonly pauseService = inject(PauseService);
    private unsubscribe$ = new Subject<void>();

    constructor() { }

    async ngOnInit(): Promise<void> {
        this.loggedScreen = this.screenLoggedService.screenLogged;
        this.environment = _.cloneDeep(environment);
        await this.pauseService.setupWebSocketCounter();
        this.pauseService.navbarCounter$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (count) => {
                    this.countPauses = count;
                },
                error: () => {
                }
            });
    }

    ngOnDestroy(): void {
        this.pauseService.disconnectWebSocketCounter();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
